import React, { useState, useEffect } from "react";
import ArrowIcon from "./ArrowIcon";
import FaqQuestion from "./FaqQuestion";

function FaqCategory({ item, selectedQuestion, myRef }) {
  const [showQuestions, setShowQuestions] = useState(true);

  useEffect(() => {
    if (selectedQuestion !== undefined) {
      item.questions.forEach(
        (i) =>
          i.question === selectedQuestion.question && setShowQuestions(true)
      );
    }
  }, [selectedQuestion]);

  return (
    <>
      <section
        className="CallToAction bg-white hds-text-color cursor-pointer"
        onClick={() => setShowQuestions(!showQuestions)}
      >
        <div className="hds-section-sm flex flex-wrap md:justify-center border-b border-black">
          <div className="w-full relative">
            <p className="text-2xl font-bold uppercase font-heading">
              {item.categoryTitle}
            </p>
            <div className="flex justify-end flex-wrap md:flex-no-wrap ">
              <button
                type="button"
                className="sm:absolute w-10 top-0 mt-5 -mr-5"
              >
                <ArrowIcon showQuestions={showQuestions} />
              </button>
            </div>
          </div>
        </div>
      </section>
      {showQuestions &&
        item.questions.map((item, index) => {
          return (
            <FaqQuestion
              key={index}
              ref={
                selectedQuestion !== undefined &&
                item.question === selectedQuestion.question
                  ? myRef
                  : null
              }
              selectedQuestion={
                selectedQuestion !== undefined &&
                item.question === selectedQuestion.question
                  ? true
                  : false
              }
              answer={item.answer}
              question={item.question}
            />
          );
        })}
    </>
  );
}

export default FaqCategory;
